export default __webpack_public_path__ + "static/media/mu.e3207be0.svg";